import { BonusSubtype } from '@core/models/bonus/BonusSubtype';
import { BonusType } from '@superbet-group/web.types';

export function isSportOrFreeBetBonus(type: BonusType) {
    return type === BonusType.Sport || type === BonusType.Freebet;
}

export function isFreeBetBonus(type: BonusType) {
    return type === BonusType.Freebet;
}

export function isSportWageringBonus(type: BonusType) {
    return type === BonusType.Sport;
}

export function isCasinoBonus(type: BonusType) {
    return type === BonusType.Casino
        || type === BonusType.CasinoVirtuals
        || type === BonusType.Virtuals
        || type === BonusType.LiveDealer;
}

export function isFreeSpinBonus(type: BonusType) {
    return type === BonusType.FreeSpins;
}

export function isBingoBonus(type: BonusType) {
    return type === BonusType.Bingo;
}

// Bonuses that have free items instead of money
export function isFreeRewardItemBonus(type: BonusType) {
    return type === BonusType.FreeSpins
        || type === BonusType.Bingo;
}

export function isWageringBonus(bonusSubtype: BonusSubtype) {
    return bonusSubtype === BonusSubtype.Wagering;
}
